<span class="flex items-center gap-2 status">
    <span
        class="h-3 w-3 rounded-full"
        [ngClass]="{
            'bg-success-600': isResultAsRequested(),
            'bg-secondary-300': !isResultAsRequested(),
        }"
        aria-hidden="true"
    >
    </span>
    <span class="status-text">{{ params.value }}</span>
</span>
